import {
	type UseMutationOptions,
	useMutation,
	useQueryClient
} from '@tanstack/react-query'
import {
	type HttpEditExperienceShellPhotoCoverOptions,
	httpEditExperienceShellPhotoCover
} from '@/features/experience-shell/http/experience-shell.http.ts'
import { errorHandler } from '@/helpers/utils'
import { QUERY_KEYS } from '@/query-client'

export const useEditExperienceShellPhotoCover = (
	urlParams: HttpEditExperienceShellPhotoCoverOptions['urlParams'],
	options?: UseMutationOptions<
		unknown,
		unknown,
		HttpEditExperienceShellPhotoCoverOptions['payload']
	>
) => {
	const queryClient = useQueryClient()
	return useMutation({
		...options,
		mutationFn: (payload) =>
			httpEditExperienceShellPhotoCover({ urlParams, payload }),
		onError: (error, variables, onMutateResult, context) => {
			errorHandler(error)
			options?.onError?.(error, variables, onMutateResult, context)
		},
		onSuccess: (data, variables, onMutateResult, context) => {
			queryClient.invalidateQueries({
				queryKey: [QUERY_KEYS.EXPERIENCE_VETTING]
			})
			options?.onSuccess?.(data, variables, onMutateResult, context)
		}
	})
}
